<template>
    <p class="my-2">Il s'agit des services fournis par les garagistes ou vulcanisateurs</p>

    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouveau service
    </button>

    <DataTableBackend v-if="dataReady" :url="'/api/' + table" :columns="columns" :table="table" :perPage="6">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
    <div v-else class="d-flex justify-content-center my-3">
        <div class="spinner-border text-primary" role="status">

        </div>
    </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
const CreateService = defineAsyncComponent(() => import('./CreateService.vue'));
const ShowService = defineAsyncComponent(() => import('./ShowService.vue'));

export default defineComponent({
    name: 'IndexService',
    data() {
        return {
            table: 'services',
            baseUrl: this.$store.state.api_yams_interventions,
            isLoading: false,
            dataReady: false,
            columns: [
                {
                    key: 'id',
                    label: 'ID',
                },
                {
                    key: 'libelle',
                    label: 'Nom',
                    exportable: true
                }
            ]
        }
    },
    mounted() {
        this.checkApiAvailability();
    },
    methods: {
        checkApiAvailability() {
            this.isLoading = true;
            this.axios.get('/api/' + this.table + '?limit=1')
                .then((response) => {
                    this.dataReady = true;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.error("Erreur lors du chargement des services:", error);
                    // Réessayer après un court délai
                    setTimeout(() => this.checkApiAvailability(), 2000);
                });
        },
        openCreateModal() {
            this.$dialog.open(CreateService, {
                props: {
                    header: "Nouveau service",
                    style: {
                        width: '20vw'
                    },
                    modal: true
                }
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowService, {
                props: {
                    header: "Service N°"+objData.id,
                    style: {
                        width: '20vw'
                    },
                    modal: true
                },
                data: objData
            });
        }
    }
});
</script>